<script setup lang="ts">
import { Heading } from "~/components/clarity-ui/Heading";
import { Tint } from "~/components/clarity-ui/Tint";
import useAccountTracking from "~/composables/tracking/useAccountTracking";
import CommonLabel from "~/templates/components/CommonLabel.vue";

const { trackAccountModification } = useAccountTracking();

const { $msal } = useNuxtApp();

const { azureUser } = useAzureUser();
const { user } = useUser();

const onChangePassword = () => {
  trackAccountModification("modify password");
  $msal.passwordChange();
};
const onChangeEmail = () => {
  trackAccountModification("modify email");
  $msal.emailChange();
};
</script>

<template>
  <div class="flex h-full flex-col gap-4">
    <Heading size="small" tag="h2">
      <CommonLabel path="BWF/shop/account/profile/accessData" />
    </Heading>

    <div>
      <CommonLabel path="BWF/shop/shared/emailAddress" />&nbsp;{{ user?.email }}
      <Tint v-if="azureUser?.username !== user?.email" class="mt-4" tag="div">
        <CommonLabel path="BWF/shop/shared/emailAddressUpdateInProgress" />
        {{ azureUser?.username }}
      </Tint>
    </div>

    <div class="mt-2 flex flex-col gap-4 xl:flex-row">
      <button
        class="btn btn-blue btn-size-sm xl:btn-size-normal md:place-self-start"
        @click="onChangeEmail"
      >
        <CommonLabel path="BWF/shop/account/profile/changeEmailAddress" />
      </button>

      <button
        class="btn btn-blue btn-size-sm xl:btn-size-normal md:place-self-start"
        @click="onChangePassword"
      >
        <CommonLabel path="BWF/shop/account/profile/changePassword" />
      </button>
    </div>
  </div>
</template>
